import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector , useDispatch} from 'react-redux';
import { Helmet } from 'react-helmet';
import { MapPin, Calendar } from '@phosphor-icons/react';
import { Button, Modal, notify } from 'app/components';
import { getResaleEventById } from './api';
import TicketAlert from './components/ticketAlert';
import TicketCard from './components/ticketCard';
import TicketList from './components/ticketList';
import Community from './components/community';
import useLoginModal from '../login/useLoginModal';
import NotFound from '../not-found/notFound';
import './style';
// import { BookedLisitng, BookingCard, BookingDetail, BookingSuccess } from './components';
// import { bookingDetails, event } from './components/data';
import { analyticEventLogger, isValidURL } from '../../utils/commonUtils';
import { LOCATION_BUYER_PAGE_EVENT_CLICK, SELLER_TICKET_EVENTPAGE_EVENT_CLICK } from '../../constants/eventLogger';
import mixpanel from 'mixpanel-browser';

const BuyerFlow = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [overlay, setOverlay] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginModal = useLoginModal();

  const { userData, cities } = useSelector((state) => state.app);
  const { selectedCategory } = useSelector((state) => state.buyerFlow);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    const storedCity = localStorage.getItem('selectedCity');

    getResaleEventById(id, true, (data) => {
      if (data?.failure) {
        setEventData(null);
        setLoading(false);
      } else {
        setEventData(data);
        setLoading(false);
        if (!storedCity) {
          const cityMatch = cities?.find(
            (option) => option.label === data.city,
          );
  
          if (cityMatch) {
            dispatch({
              type: 'SELECTED_CITY:DATA:SET',
              data: cityMatch,
            });
            localStorage.setItem('selectedCity', JSON.stringify(cityMatch));
          }
        }
      }
    });
  }, [id, cities]);

  useEffect(() => {
    if (selectedCategory) setOverlay(true);
  }, [selectedCategory]);

  useEffect(() => () => dispatch({ type: 'TICKET_DETAILS:RESET' }), []);

  const handleOpen = (category) => {
    if (!overlay) setOverlay(true);
    dispatch({ type: 'TICKET_DETAILS:SELECTED_CATEGORY:SET', data: category });
  };

  const handleClose = () => {
    setOverlay(false);
  };

  const onClickSellTicket = () => {
    analyticEventLogger(SELLER_TICKET_EVENTPAGE_EVENT_CLICK, {
      isAuthenticated: !!userData?.email
    });
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = () =>
        navigate('/sell-tickets', {
          state: { eventId: eventData._id },
        });
    } else {
      mixpanel.track("Resell_Tickets_Clicked", {
        "event_id": eventData?._id || null,
        "event_name": eventData?.name || "N/A",
        "user_id": userData._id || "Anonymous",
        "page_url": window.location.href,
      });
[]
      navigate('/sell-tickets', {
        state: { eventId: eventData._id },
      });
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Define formatting options for the date and time
    const weekdayOptions = { weekday: 'short' };
    const monthDayOptions = { month: 'short', day: 'numeric' };
    const timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

    // Format the components
    const weekday = new Intl.DateTimeFormat('en-US', weekdayOptions).format(
      date,
    );
    const monthDay = new Intl.DateTimeFormat('en-US', monthDayOptions).format(
      date,
    );
    const time = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

    // Combine formatted components
    return `${weekday}, ${monthDay} at ${time}`;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!/^[a-f\d]{24}$/i.test(id)) {
    return <NotFound />;
  }

  if (!loading && !eventData?.name) {
    return <NotFound />;
  }

  return (
    <div className="buyerFlow bg-grey-5">
      <Helmet>
        <title>{eventData?.name}</title>
        <meta
          name="description"
          content={`Buy and sell tickets for the event ${eventData?.name}`}
        />
      </Helmet>
      {overlay ? (
        <TicketList
          eventData={eventData}
          onClick={handleClose}
          handleOpen={handleOpen}
          cat={selectedCategory}
        />
      ) : (
        <>
          <div
            className="eventBg"
            style={{
              background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 9.25%, 
                    rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 0.393) 92.13%), 
                    url(${eventData?.image}) lightgray 0px -127.411px / 100% 171.591% no-repeat`,
            }}
          ></div>
          <div className="eventContainer">
            <div
              className="eventImgContainer"
              style={{
                background: `url('${eventData?.image}') lightgray 0px -130.933px / 100% 161.191% no-repeat`,
              }}
            ></div>

            <div className="eventDescription">
              <h1 className="eventHeading">{eventData?.name}</h1>
              <div className="eventLocaleContainer">
                <div className="eventLocale">
                  <div className="p-[10px] flex justify-center items-center bd">
                    <MapPin className="eventIcon"
                      size={28} />
                  </div>
                  {isValidURL(eventData?.googleMapURI) ? (
                    <a
                      href={eventData.googleMapURI}
                      className="text-16 no-underline text-black"
                      target="_blank"
                      onClick={() => analyticEventLogger(LOCATION_BUYER_PAGE_EVENT_CLICK, {})}
                    >
                      {eventData?.venue}, {eventData?.city}
                    </a>
                  ) : (
                    <p className="text-16">
                      {eventData?.venue}, {eventData?.city}
                    </p>
                  )}
                </div>

                <div className="eventLocale">
                  <div className="p-[10px] flex justify-center items-center bd">
                    <Calendar className="eventIcon"
                      size={28} />
                  </div>
                  <p className="text-16">{formatDate(eventData?.start_date)}</p>
                </div>
              </div>
            </div>
            {eventData?.is_community&&(   
              <div className="w-full" >
                <Community
                  eventData={eventData}
                  is_community={eventData?.is_community}
                  community_link={eventData?.community_link}
                />
              </div>
            )}
            {eventData?.disallow_ticket_selling ? (
              <div className='ticket-sell-warning bg-light rounded-xl px-6 py-5 flex flex-col items-center gap-4 w-full'>
                <div className='text-primary heading-24'>👀 Heads Up!!!</div>
                <div className='flex flex-col gap-6'>
                  <div className='flex gap-3 items-start md:items-center'>
                    <div className='heading-24'>🎫</div>
                    <div className='label-16'>Ticket buying and selling above face value is illegal in India.</div>
                  </div>
                  <div className='flex gap-3 items-start md:items-center'>
                    <div className='heading-24'>🚗</div>
                    <div className='label-16'>Use this community only to connect, carpool, or plan for the event.</div>
                  </div>
                  <div className='flex gap-3 items-start md:items-center'>
                    <div className='heading-24'>🚨</div>
                    <div className='label-16'>Take My Tickets is not responsible for any transactions between users.</div>
                  </div>
                </div>
              </div>
            ) : (
              <>
            <div className="w-full flex flex-col gap-8 descri">
              <div className="flex w-full justify-between">
                <h1 className="eventHeading">Tickets</h1>
                <Button
                  className="ml-auto sell-btn"
                  onClick={onClickSellTicket}
                >
                  Sell tickets
                </Button>
              </div>

              {eventData?.ticketCategories?.length > 0 ? (
                <div className="flex flex-col gap-2">
                  {window.innerWidth > 650 ? (
                    <img src="assets/images/banner.svg" />
                  ) : (
                    <img src="assets/images/banner-mobile.svg" />
                  )}
                  <TicketAlert eventData={eventData} />
                </div>
              ) : (
                <>
                  <TicketAlert eventData={eventData} />
                  <div className="heading-16 px-6 py-5 border border-grey-10 mt-3 mb-8">
                    No tickets available!
                  </div>
                  <div className="bg-light px-6 py-5 flex items-start justify-between rounded-xl">
                    <div className="flex flex-col gap-3">
                      <div className="heading-16">
                        Looking to sell your tickets?
                      </div>
                      <div className="text-14">
                        List your tickets now and sell them fast.
                      </div>
                      <Button onClick={onClickSellTicket}>Sell tickets</Button>
                    </div>
                    <div className="text-5xl px-1.5 py-3 bg-white rounded-full justify-center">
                      🤔
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="ticketContainer">
              {eventData?.ticketCategories?.map((category) => (
                <TicketCard
                  type="active"
                  onClick={() => {
                    mixpanel.track("Category_Clicked", {
                      "event_id": eventData?._id,                 
                      "event_name": eventData?.name,             
                      "category_name": category?.categoryName,        
                      "category_ticket_count": category?.availableTicket,
                      "user_id": userData?._id || "Anonymous",    
                      "page_url": window.location.href,  
});
                    handleOpen(category);
                  }}
                  category={category}
                />
              ))}
            </div>
              </>
            )}
          </div>
        </>
      )}
      {/* <BookingListing {...event} /> */}
      {/* <BookingSucess {...user}/> */}
      {/* <BookingDetail 
        eventName="Event Name"
        eventCategory="Category"
        eventType="offline"
        dateRange="Jan 1 - Jan 3"
        time="10:00 AM"
        venue="Event Venue"
        code="ABC123"
        mail="example@mail.com"
        phoneNumber="123-456-7890"
        purchaseDate="Dec 25"
        onReloadClick={() => console.log('Reload tickets')}
        onDownloadClick={() => console.log('Download tickets')}
        onDirectionsClick={() => console.log('Get directions')}
        onJoinClick={() => console.log('Join event')}
      /> */}
    </div>
  );
};

export default BuyerFlow;
